import { DirectLineActivity } from "botframework-webchat-core";

const startForm = (formId: string) => {
  if (formId.length > 0) {
    console.log(`Start form : ${formId}`);
    sendActivity({
      type: "event",
      name: "StartFormEvent",
      value: {
        type: 0,
        formId: formId,
        sectionId: "0",
      },
    });
    //setShowTestMenu(false);
  }
};

const sendActivity = (activity: DirectLineActivity) => {
  const customActEvent = new CustomEvent("retorikSendActivity", {
    detail: {
      meta: {
        method: "speech",
      },
      ...activity,
    },
  });
  document.dispatchEvent(customActEvent);
};

const GetActivityCounter = (): number => {
  let stored = localStorage.getItem("activityCount");
  if (stored) return parseInt(stored);
  else return 0;
};

const UpdateActivityCounter = (operator: string): void => {
  let stored = localStorage.getItem("activityCount");
  if (operator === "reset") {
    localStorage.setItem("activityCount", "0");
  }
  if (!stored && operator === "+") {
    localStorage.setItem("activityCount", "1");
  } else if (!stored && operator === "-")
    localStorage.setItem("activityCount", "0");
  else if (stored) {
    let numberOfActivity = parseInt(stored);
    if (operator === "+") numberOfActivity++;
    else if (operator === "-") numberOfActivity--;
    localStorage.setItem("activityCount", numberOfActivity.toString());
  }
};

const GetActivityVoiceWaiting = (): {
  idActivity: string;
  wait: boolean;
} | null => {
  let stored = localStorage.getItem("WaitForVoiceFinish");
  if (stored) {
    let storedObj = JSON.parse(stored);
    return storedObj;
  } else return null;
};

const UpdateActivityVoiceWaiting = (
  wait: boolean,
  idActivity?: string
): void => {
  let stored = localStorage.getItem("WaitForVoiceFinish");
  if (wait) {
    localStorage.setItem(
      "WaitForVoiceFinish",
      JSON.stringify({ idActivity: idActivity, wait: wait })
    );
  } else {
    if (stored) {
      localStorage.removeItem("WaitForVoiceFinish");
    }
  }
};

export {
  startForm,
  sendActivity,
  GetActivityCounter,
  UpdateActivityCounter,
  GetActivityVoiceWaiting,
  UpdateActivityVoiceWaiting,
};
